import { Head } from "@inertiajs/react"
import { Heading } from "~/components/ui/heading";

export default function ({ content }) {
  return (
    <div className="container mx-auto py-8 space-y-8">
      <Head title={content.name} />
      <Heading size="h1">{content.name}</Heading>
      <div className="prose max-w-none" dangerouslySetInnerHTML={{ __html: content.content_as_html}}>
        
      </div>
    </div>
  )
}